export default {
  ACCELERATE_LANDING: 'acceleratelanding',
  CAR_LOADS: 'carloans',
  CAR_VANTAGE: 'carvantage',
  // CMSContentPage: 'CMSContentPage',
  CREDIT_APP: 'creditapp',
  DEALER_DETAILS: 'dealerdetails',
  DEALER_DETAILS_KBB: 'dealerdetailskbb',
  DEALER_SEARCH: 'dealersearch',
  DEALER_SEARCH_KBB: 'dealersearchkbb',
  ERROR: 'error',
  EXPERIMENT_LIST: 'experimentlist',
  FORD_LANDING: 'fordlanding',
  FORD_PRIVACY_POLICY: 'fordprivacypolicy',
  FORD_CONSUMER_PRIVACY: 'fordconsumerprivacy',
  FORD_VISITOR_AGREEMENT: 'fordvisitoragreement',
  FORD_ACCESSIBILITY_STATEMENT: 'fordaccessibilitystatement',
  HOMEPAGE: 'hp',
  MARKETPLACE_LANDING: 'marketplacelanding',
  MARKETPLACE_SEARCH: 'marketplacesearch',
  MARKETPLACE_DETAILS: 'marketplacedetails',
  RESEARCH_ARTICLES: 'researcharticles',
  RESEARCH_MAKE: 'researchmake',
  RESEARCH_MODEL: 'researchmodel',
  SEARCH_FORM: 'sfp',
  SEARCH_RESULTS: 'srp',
  FYC_SITEMAP: 'fycSitemap',
  UNSUBSCRIBE: 'unsubscribe',
  VEHICLE_DETAILS: 'vdp',
  VOICE_SEARCH_HELP: 'voice_search_help',
  BUILD_PRICE: 'bap'
};